import React from "react";
import { classNames } from "repoV2/utils/common/render/classNames";
import { isEmpty } from "@Utils";
import { ICustomQuestions } from "../ICustomQuestions";
import styles from "../../../userDetails.module.scss";

const PararaphTextQuestion = ({
    htmlId,
    item,
    showInputError,
    userInput,
    answers,
    setAnswers,
    editingDisabled,
}: ICustomQuestions.ITextQuestionProps) => {
    const castedUserInput = (userInput as string) || "";

    const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setAnswers({ ...answers, [e.target.name]: e.target.value });
    };

    return (
        <div className={classNames(styles.fieldContainer, styles.flexCol)}>
            <textarea
                id={htmlId}
                className={classNames(
                    styles.formInput,
                    editingDisabled && styles.editingDisabled,
                    showInputError && isEmpty(castedUserInput)
                        ? styles.formInputError
                        : false
                )}
                name={item.uuid}
                onChange={handleChange}
                value={castedUserInput}
                rows={3}
                disabled={editingDisabled}
                {...item.validations}
            />
            <div className={styles.fieldError}>
                {showInputError && isEmpty(castedUserInput) ? (
                    "Please enter an answer"
                ) : (
                    <>&nbsp;</>
                )}
            </div>
        </div>
    );
};

export default PararaphTextQuestion;
